import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzUploadFile, NzUploadModule } from 'ng-zorro-antd/upload';
import { Observable, Observer } from 'rxjs';

@Component({
  selector: 'korviu-avatar-upload',
  standalone: true,
  imports: [NzAvatarModule, NzUploadModule, NzIconModule, TranslateModule],
  templateUrl: './korviu-avatar-upload.component.html',
  styleUrls: ['./korviu-avatar-upload.component.scss']
})
export class KorviuAvatarUploadComponent {
  @Input() uploadPath: string;
  @Input() avatarUrl!: string;
  @Output() avatarUrlChange: EventEmitter<string>;

  public fileIsLoading: boolean;

  constructor() {
    this.fileIsLoading = false;
    this.uploadPath = '';
    this.avatarUrl = '';
    this.avatarUrlChange = new EventEmitter<string>();
  }

  public beforeUpload(file: NzUploadFile, _fileList: NzUploadFile[]): Observable<boolean> {
    return new Observable((observer: Observer<boolean>) => {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        console.error('You can only upload JPG/PNG file!');
        observer.complete();
        return;
      }
      const isLt2M = file.size! / 1024 / 1024 < 2;
      if (!isLt2M) {
        console.error('Image must smaller than 2MB!');
        observer.complete();
        return;
      }
      observer.next(isJpgOrPng && isLt2M);
      observer.complete();
    });
  }

  private getBase64(img: File, callback: (img: string) => void): void {
    const reader: FileReader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result!.toString()));
    reader.readAsDataURL(img);
  }

  public handleChange(info: { file: NzUploadFile }): void {
    switch (info.file.status) {
      case 'uploading':
        this.fileIsLoading = true;
        break;
      case 'done':
        this.getBase64(info.file!.originFileObj!, (img: string) => {
          this.fileIsLoading = false;
          this.avatarUrl = img;
          this.avatarUrlChange.emit(this.avatarUrl);
        });
        break;
      case 'error':
        console.error('Network error');
        this.fileIsLoading = false;
        break;
    }
  }
}
